"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpCancelError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
var HttpCancelError = /** @class */ (function (_super) {
    tslib_1.__extends(HttpCancelError, _super);
    function HttpCancelError(message, domain) {
        if (domain === void 0) { domain = 'httpApi'; }
        var _this = _super.call(this, { type: 'CancelError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, HttpCancelError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpCancelError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpCancelError;
}(genericError_js_1.GenericError));
exports.HttpCancelError = HttpCancelError;
//# sourceMappingURL=httpCancelError.js.map